import React from 'react';
import { IconButton, Button, List, ListItemButton, ListItemText, ListItemSecondaryAction, Box, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ContentBlock } from '../../shared/sharedStyles';

export const LeftSideBlock = ({ courseSteps, handleStepClick, selectedStep, handleEdit, handleDelete, handleShowAdd }) => {

    return (
        <ContentBlock 
            variant="outlined" 
            elevation={0} 
            sx={{ 
                p: 0, 
                m: "0px !important", 
                width: { xs: "100%", md: "30%" }, 
                height: { xs: "auto", md: "100%" },
                maxHeight: { xs: "300px", md: "none" },
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
            }} 
        >
            <Box sx={{ 
                p: { xs: 1.5, sm: 2 }, 
                borderBottom: '1px solid #e0e0e0',
                backgroundColor: '#fafafa'
            }}>
                <Typography 
                    variant="subtitle2" 
                    fontWeight={500} 
                    sx={{ 
                        color: '#6c757d',
                        fontSize: { xs: '0.8125rem', sm: '0.875rem' },
                        letterSpacing: '0.02em',
                        textTransform: 'uppercase'
                    }}
                >
                    Course Steps
                </Typography>
            </Box>
            <List sx={{ 
                width: "100%", 
                overflow: "auto",
                p: { xs: 1, sm: 1.5 },
                '& .MuiListItemButton-root': {
                    borderRadius: '8px',
                    mb: 0.5,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        backgroundColor: '#f8f9fa',
                        transform: 'translateX(4px)'
                    },
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(220, 53, 69, 0.1)',
                        borderLeft: '4px solid #dc3545',
                        '&:hover': {
                            backgroundColor: 'rgba(220, 53, 69, 0.15)'
                        }
                    }
                }
            }}>
                {courseSteps.map((step, index) => (
                    <ListItemButton 
                        selected={selectedStep?.id === step.id} 
                        key={index} 
                        onClick={() => handleStepClick(step)}
                        sx={{
                            py: 0.75,
                            px: 1.5,
                            borderRadius: '6px',
                            mb: 0.5,
                            '&.Mui-selected': {
                                backgroundColor: 'rgba(220, 53, 69, 0.08)',
                                borderLeft: '3px solid #dc3545',
                                '&:hover': {
                                    backgroundColor: 'rgba(220, 53, 69, 0.12)'
                                }
                            }
                        }}
                    >
                        <ListItemText 
                            primary={step.stepTitle} 
                            className="step-title"
                            primaryTypographyProps={{
                                fontWeight: selectedStep?.id === step.id ? 600 : 500,
                                fontSize: '0.875rem',
                                color: selectedStep?.id === step.id ? '#dc3545' : '#495057'
                            }}
                        />
                        <ListItemSecondaryAction sx={{ display: "flex", gap: 0.25 }}>
                            <IconButton 
                                edge="end" 
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleEdit(step.id); }}
                                sx={{
                                    color: '#adb5bd',
                                    width: '28px',
                                    height: '28px',
                                    '&:hover': {
                                        color: '#dc3545',
                                        backgroundColor: 'rgba(220, 53, 69, 0.08)'
                                    }
                                }}
                            >
                                <EditIcon sx={{ fontSize: '0.875rem' }} />
                            </IconButton>
                            <IconButton 
                                edge="end" 
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleDelete(step); }}
                                sx={{
                                    color: '#adb5bd',
                                    width: '28px',
                                    height: '28px',
                                    '&:hover': {
                                        color: '#dc3545',
                                        backgroundColor: 'rgba(220, 53, 69, 0.08)'
                                    }
                                }}
                            >
                                <DeleteIcon sx={{ fontSize: '0.875rem' }} />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItemButton>
                ))}
            </List>
            <Box sx={{ p: { xs: 1.5, sm: 2 }, borderTop: '1px solid #e0e0e0', backgroundColor: '#f8f9fa' }}>
                <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={handleShowAdd}
                    fullWidth
                    sx={{ 
                        borderRadius: '6px',
                        py: 0.75,
                        borderColor: '#dc3545',
                        color: '#dc3545',
                        fontWeight: 500,
                        fontSize: { xs: '0.8125rem', sm: '0.875rem' },
                        textTransform: 'none',
                        '&:hover': {
                            borderColor: '#c82333',
                            backgroundColor: 'rgba(220, 53, 69, 0.05)',
                            borderWidth: '1.5px'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    Add Step
                </Button>
            </Box>
        </ContentBlock>
    )
}